/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { partnerClientControllerFindAllV1 } from '../fn/partner-client/partner-client-controller-find-all-v-1';
import { PartnerClientControllerFindAllV1$Params } from '../fn/partner-client/partner-client-controller-find-all-v-1';
import { partnerClientControllerFindByIdV1 } from '../fn/partner-client/partner-client-controller-find-by-id-v-1';
import { PartnerClientControllerFindByIdV1$Params } from '../fn/partner-client/partner-client-controller-find-by-id-v-1';
import { PartnerDto } from '../models/partner-dto';

@Injectable({ providedIn: 'root' })
export class PartnerClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `partnerClientControllerFindAllV1()` */
  static readonly PartnerClientControllerFindAllV1Path = '/api/v1/partners/client';

  /**
   * 파트너 전체 조회.
   *
   * 노출 중인 파트너 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerClientControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerClientControllerFindAllV1$Response(params?: PartnerClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerDto>>> {
    const obs = partnerClientControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 전체 조회.
   *
   * 노출 중인 파트너 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerClientControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerClientControllerFindAllV1(params?: PartnerClientControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PartnerDto>> {
    const resp = this.partnerClientControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PartnerDto>>): Array<PartnerDto> => r.body)
    );
  }

  /** Path part for operation `partnerClientControllerFindByIdV1()` */
  static readonly PartnerClientControllerFindByIdV1Path = '/api/v1/partners/client/{id}';

  /**
   * 파트너 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerClientControllerFindByIdV1$Response(params: PartnerClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerDto>> {
    const obs = partnerClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerClientControllerFindByIdV1(params: PartnerClientControllerFindByIdV1$Params, context?: HttpContext): Observable<PartnerDto> {
    const resp = this.partnerClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PartnerDto>): PartnerDto => r.body)
    );
  }

}
